import React from 'react';
import { ChipCellRendererProps } from './types';
import { BaseChip } from '../../UI';
import StringUtils from '../../../utils/StringUtils';

export const ChipCellRenderer: React.FC<ChipCellRendererProps> = React.memo(
  ({ mapStatusToSeverity, value }) => (
    <BaseChip
      severity={mapStatusToSeverity(value)}
      label={StringUtils.ConvertTitleCase(value)}
    />
  ),
);
